<template>
  <form
    class="filter-bar sticky-top"
    :class="classes"
  >
    <div class="d-flex p-2 bg-body rounded shadow">
      <slot />
    </div>
  </form>
</template>

<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
  },

  computed: {
    classes() {
      if (!this.visible) {
        return []
      }

      return [
        'filter-bar--visible',
        'mb-3'
      ];
    }
  }
}
</script>